import { axios } from '../../../lib'

export const getPartnerIbans = ({
  partnerCifs = null,
  partnerGroups = null,
  worldClassCifs = null,
  searchTerm = null,
  pageNumber = null,
  size = null,
  orderByList = null
}) => {
  return axios.post('/v2/nomenclatures/partners/ibans/paginate', {
    partnerCifs,
    partnerGroups,
    worldClassCifs,
    searchTerm,
    pagination: {
      ...(pageNumber == null || size == null
        ? { pageNumber: null, size: null }
        : { pageNumber, size }),
      orderByList
    }
  })
}
